import { AppState } from '@/vuex/store';
import { Account } from '@/common/models/Account';

export default {
  UPDATE_ACCOUNT: (state: AppState, account: Account) => {
    if (account !== null) {
      state.accountState.hasLoginAcount = true;
    }
    state.accountState.hasLogin = true;
    if (!state.accountState.account || (state.accountState.account.id !== account.id)) {
      state.accountState.changeAccountNum = state.accountState.changeAccountNum + 1;
    }
    state.accountState.account = account;
  },
  UPDATE_CRM_LEVEL: (state: AppState, crmLevel: any) => {
    state.accountState.crmLevel = crmLevel;
    state.accountState.changeCrmLevelNum = state.accountState.changeCrmLevelNum + 1;
  },
  UPDATE_IS_TRIAL: (state: AppState, isTrial: boolean) => {
    state.accountState.isTrial = isTrial;
  },
  UPDATE_FANS_LEVEL: (state: AppState, fansLevel: number) => {
    state.accountState.fansLevel = fansLevel;
  },
  UPDATE_IS_EXPIRED: (state: AppState, isExpired: boolean) => {
    state.accountState.isExpired = isExpired;
  },
  LOGIN_OUT: (state: AppState) => {
    state.accountState.hasLoginAcount = false;
    state.accountState.hasLogin = false;
    state.accountState.account = undefined;
  },
};

